(function(Drupal, once) {

  Drupal.behaviors.footer_nav_mobile_collapse = {

    attach(context) {
      once('footer-nav', '.footer_nav__primary-menus nav', context)
        .forEach(el => {
          let elMenu = el.querySelector('.menu');
          let elTitle = el.querySelector('h2')
          //  @TODO: change this variable to match breakpoint
          let breakpoint = '1024'
          elTitle.addEventListener('click',function(){
            if(window.innerWidth < breakpoint){
              if( document.querySelector('.footer_nav__primary-menus nav .active') &&!elMenu.classList.contains('active') ){
                let active = document.querySelector('.footer_nav__primary-menus nav .active')
                toggleOpen(active)
                active.classList.remove('active')

              }
              elMenu.classList.toggle('active');
              toggleOpen(elMenu)
              let openMenu = document.querySelector('.footer_nav__primary-menus nav[open=true] ')
              toggleOpen(el)
              if(openMenu && openMenu!=el){
                toggleOpen(openMenu)
              } 

            }
          })
        });
    },
  };

  Drupal.behaviors.footer_search = {

    attach(context) {
      let footerSearch= document.querySelector('.footer_nav__search');
      let toggle =  footerSearch.querySelector('.search-toggle');
      let searchBlock = footerSearch.querySelector('.search-block')
          
          toggle.addEventListener('click',function(e){
            if(!e.handled)
              searchBlock.classList.toggle('active');

              e.handled= true;
          })
      }
  }
  function toggleOpen(element) {
    element.getAttribute('aria-expanded') === 'true'
      ? element.setAttribute('aria-expanded', 'false')
      : element.setAttribute('aria-expanded', 'true')
  }
})(Drupal, once);
